import {dateTime} from "services/date";
import {AppInfo} from "types/AppInfo";

/**
 * Transform the given article by deserializing object properties
 *
 * @internal
 * @param app
 */
export default function deserializeAppInfo(app: any): AppInfo {
    app.published_at = dateTime(app.published_at)
    app.created_at = dateTime(app.created_at)
    app.updated_at = dateTime(app.updated_at)

    return app;
}